import { MessageCircle, Mail, Facebook, Instagram } from "lucide-react";
import { Reveal } from "./Reveal";
import { EMAIL, PHONE_DISPLAY, WHATSAPP_URL, SOCIALS } from "../data/content";

export default function Footer() {
  return (
    <footer data-testid="footer" className="noise relative bg-[#0A0A0A] border-t border-[#F9F9F6]/10 pt-24 pb-10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="font-serif-e text-[13vw] lg:text-[9rem] leading-[0.95] tracking-tighter text-[#F9F9F6]" data-testid="footer-headline">
            Where every<br />detail <em className="text-[#D4AF37]">matters.</em>
          </p>
        </Reveal>
        <div className="grid md:grid-cols-12 gap-10 mt-16 items-end">
          <Reveal className="md:col-span-4">
            <div className="flex flex-wrap gap-3">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-btn"
                 className="flex items-center gap-2 rounded-full border border-[#D4AF37]/50 text-[#D4AF37] px-6 py-3 text-xs uppercase tracking-[0.15em] hover:bg-[#D4AF37] hover:text-[#0A0A0A] transition-colors">
                <MessageCircle size={14} strokeWidth={1.5} /> {PHONE_DISPLAY}
              </a>
              <a href={`mailto:${EMAIL}`} data-testid="footer-email-btn"
                 className="flex items-center gap-2 rounded-full border border-[#F9F9F6]/25 text-[#F9F9F6] px-6 py-3 text-xs uppercase tracking-[0.15em] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                <Mail size={14} strokeWidth={1.5} /> Email Us
              </a>
            </div>
            <p className="text-[#F9F9F6]/40 text-xs mt-6 leading-relaxed max-w-xs">
              Novaphi Catering &amp; Events — Exceptional Food. Thoughtful Presentation. Memorable Experiences.
            </p>
            <div className="flex gap-3 mt-5">
              <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" aria-label="Novaphi on Facebook"
                 className="w-10 h-10 rounded-full border border-[#F9F9F6]/25 flex items-center justify-center text-[#F9F9F6]/70 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                <Facebook size={16} strokeWidth={1.5} />
              </a>
              <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" aria-label="Novaphi on Instagram"
                 className="w-10 h-10 rounded-full border border-[#F9F9F6]/25 flex items-center justify-center text-[#F9F9F6]/70 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                <Instagram size={16} strokeWidth={1.5} />
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-5">
            <div className="grid grid-cols-2 gap-8">
              <div>
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] mb-4">Explore</p>
                <ul className="space-y-2.5 text-sm text-[#F9F9F6]/60">
                  <li><a href="#services" data-testid="footer-link-services" className="gold-underline hover:text-[#F9F9F6] transition-colors">Services</a></li>
                  <li><a href="#shop" data-testid="footer-link-shop" className="gold-underline hover:text-[#F9F9F6] transition-colors">Shop</a></li>
                  <li><a href="/menu" data-testid="footer-link-menus" className="gold-underline hover:text-[#F9F9F6] transition-colors">Menus</a></li>
                  <li><a href="#story" data-testid="footer-link-story" className="gold-underline hover:text-[#F9F9F6] transition-colors">Our Story</a></li>
                  <li><a href="#contact" data-testid="footer-link-quote" className="gold-underline hover:text-[#F9F9F6] transition-colors">Request a Quote</a></li>
                </ul>
              </div>
              <div>
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] mb-4">Good to Know</p>
                <ul className="space-y-2.5 text-sm text-[#F9F9F6]/60">
                  <li data-testid="footer-info-collection">Collection: 1 Coldstream St, Little Falls, Roodepoort 1724</li>
                  <li data-testid="footer-info-deadline">Weekly meal prep orders close Sundays</li>
                  <li data-testid="footer-info-deposit">80% deposit secures your slot</li>
                  <li data-testid="footer-info-delivery">Uber/Bolt delivery (JHB) · Bobgo courier for pantry items</li>
                </ul>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.2} className="md:col-span-3 md:text-right">
            <img src="/assets/logo-white.png" alt="Novaphi Catering logo" data-testid="footer-logo" className="h-24 w-auto md:ml-auto" />
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#F9F9F6]/40 mt-3">Black. White. Gold.</p>
          </Reveal>
        </div>
        <div className="h-px bg-[#F9F9F6]/10 mt-14 mb-6" />
        <div className="flex flex-col md:flex-row justify-between gap-3 text-[10px] uppercase tracking-[0.2em] text-[#F9F9F6]/30">
          <p>© {new Date().getFullYear()} Novaphi Catering &amp; Events. All rights reserved.</p>
          <p>A women-powered South African brand.</p>
        </div>
      </div>
    </footer>
  );
}
